// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1gNH-","title":"InfoRow_title__1qxmI"};